export * from 'utils/bolt/dynamicData.js';
// import * as base from 'utils/bolt/dynamicData.js';
import Store from 'store/store';
import { isImage, isNativeVideo, isYoutube, getYoutubeId } from 'utils/cms/mediaFiles';
import formatDateTime from 'utils/formatDateTime';

function getHeroButton(data, button) {
	if (!button) return;
	let link = button.link;
	let label = button.label;
	if (link === '#tickets' && data.watch?.showShowtimes) {
		link = `${data.url}-showtimes`;
	}
	if (link === '#homeEnt' && data.watch?.showHomeEnt) {
		link = `${data.url}-homeEnt`;
	}
	if (button.autoTickets) {
		label = null;
		link = null;
		const today = formatDateTime(new Date(), 'yyyy-MM-dd');
		const date = data?.dates?.boxOffice || data?.dates?.release;
		if (date) {
			if (today < date) {
				label = 'Save to Calendar';
				link = `@calendarreminder::${date}`;
			} else if (data?.watch?.showShowtimes) {
				label = 'Get Tickets';
				link = `${data.url}-showtimes`;
			}
		}
	}
	return { label, link };
}

export function transformPageData(data) {
	const appData = Store.get().appData;

	const youtubeMatch = data.hero?.youtube?.match(/[&?]v=([^&#]+)|youtu\.be\/([^?&#]+)|^([a-z0-9_-]+)$/i);
	const youtubeId = youtubeMatch?.[1] || youtubeMatch?.[2] || youtubeMatch?.[3];

	const homeEntData = data.watch?.homeEntData;
	const finalData = {};
	if (homeEntData) {
		for (let merchant of homeEntData) {
			if (!finalData[merchant.format]) {
				finalData[merchant.format] = {};
			}
			finalData[merchant.format][merchant.name] = {
				merchantName: merchant.name,
				[merchant.availability]: [{ link: merchant.link }]
			};
		}
	}

	const landingPage = data.landingPage || 'about';
	const filmPageSubPath = landingPage === 'about' ? '/' : '/about-the-film/';
	const showtimesPageSubPath = landingPage === 'showtimes' ? '/' : '/tickets/';
	const homeEntPageSubPath = landingPage === 'homeEnt' ? '/' : '/watch-at-home/';


	return [
		{
			base: 'bolt',
			id: data.url,
			data: [
				{
					id: 'filmHero',
					component: 'heroSpot',
					data: {
						background: {
							alt: data.hero?.alt,
							desktop: data.hero?.img,
							mobile: data.hero?.mobileImg
						},
						buttons: data?.hero?.buttons?.map(button => getHeroButton(data, button)).filter(button => button?.label),
						description: data.hero?.description,
						hasGradient: true,
						title: data.hero?.title,
						tag: data.hero?.tag,
						trailer: !youtubeId ? undefined : {
							trailer: {
								name: '',
								thumbSrc: `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`,
								youtubeId: youtubeId
							}
						}
					},
				},
				data.synopsis?.content && {
					id: 'filmSynopsis',
					component: 'synopsis',
					data: {
						hash: 'synopsis',
						content: data.synopsis?.content,
						credits: data.synopsis?.credits?.map(e => ({ heading: e?.title, names: e?.content?.replace(/(^[^ ]|.[^ ]|[^ ].)\n/gm, '$1  \n') })).filter(e => e.names),
						onesheet: data.synopsis?.onesheet,
						onesheetAltText: data.synopsis?.onesheetAltText,
						forceExpandedView: data.synopsis?.forceExpandedView,
						enlargeOnesheet: true,
						downloadOnesheet: true,
					},
				},
				data.gallery?.length && {
					id: 'filmGallery',
					component: 'gallery',
					data: {
						hash: 'gallery',
						contentCarousel: data.gallery.map((e) => {
							if (!e.file) return;
							if (isImage(e.file)) {
								return { name: e.file, desktopSrc: e.file, tabletSrc: e.file, mobileSrc: e.file, alt: e.alt, thumbAria: e.thumbAria, annotation: e.annotation };
							}
							if (isNativeVideo(e.file)) {
								return { name: e.file, thumbSrc: e.thumbnail, thumbAria: e.thumbAria, annotation: e.annotation, noAutoplay: true, videoSrc: e.file };
							}
							if (isYoutube(e.file)) {
								const ytId = getYoutubeId(e.file);
								if (ytId) {
									return { name: e.file, youtubeId: ytId, annotation: e.annotation, noAutoplay: true };
								}
							}
						}).filter(e => e),
						downloadAll: false,
						downloadSingle: true,
						hideArrowsMobile: true,
					},
				},
			].filter(e => e),
			type: 'filmPage',
			path: '/films/' + data.url + filmPageSubPath,
			customPageComponent: 'films'
		},
		data.watch?.showShowtimes && {
			id: `${data.url}-showtimes`,
			type: 'showtimes',
			path: `/films/${data.url}${showtimesPageSubPath}`,
			data: {
				...appData?.pages?.boltShowtimes?.data,
				movieId: data.watch.movieId,
				bg: { desktop: { asset: data.watch.onesheet }, mobile: { asset: data.watch.mobileOnesheet }, tablet: { asset: data.watch.mobileOnesheet }, tabletLandscape: { asset: data.watch.mobileOnesheet } },
			},
		},
		data.watch?.showHomeEnt && {
			id: `${data.url}-homeEnt`,
			type: 'homeEnt',
			order: data.watch?.homeEntFirst ? 1 : 2,
			path: `/films/${data.url}${homeEntPageSubPath}`,
			data: {
				movieId: data.watch.movieId,
				regions: 'gb',
				bg: { desktop: { asset: data.watch.onesheet }, mobile: { asset: data.watch.mobileOnesheet }, tablet: { asset: data.watch.mobileOnesheet }, tabletLandscape: { asset: data.watch.mobileOnesheet } },
				addProducts: {
					digital: data.watch.homeEntData?.reduce?.((data, e) => {
						if (!e?.name) {
							return data;
						}
						data[e.name] = { merchantName: e.name, stream: { [e.name]: { link: e.link } } };
						return data;
					}, {})
				},
				overrideMerchantDetails: data.watch.homeEntData?.reduce?.((data, e) => {
					if (!e?.name) {
						return data;
					}
					data[e.name] = { name: e.name, logo: e.logo };
					return data;
				}, {}),
			},
		}
	].filter(e => e);
}